import {
  FETCH_STATIONS,
  FETCH_STATIONS_FAILURE,
  FETCH_STATIONS_SUCCESS,
  FETCH_STATIONS_TO,
  FETCH_STATIONS_TO_FAILURE,
  FETCH_STATIONS_TO_SUCCESS,
} from './constants';

import Api from '../../services/api';

export const requestStations = () => ({
  type: FETCH_STATIONS,
});

export const requestStationsFailure = payload => ({
  type: FETCH_STATIONS_FAILURE,
  payload,
});

export const requestStationsSuccess = payload => ({
  type: FETCH_STATIONS_SUCCESS,
  payload,
});

export const getEnterStations = (from, to) => {
  return dispatch => {
    dispatch(requestStations());
    Api.getDeparture()
      .then(res => {
        dispatch(requestStationsSuccess(res));
      })
      .catch(error => {
        dispatch(requestStationsFailure(error));
      });
  };
};

export const requestStationsTo = () => ({
  type: FETCH_STATIONS_TO,
});

export const requestStationsToFailure = payload => ({
  type: FETCH_STATIONS_TO_FAILURE,
  payload,
});

export const requestStationsToSuccess = (fromStationId, payload) => ({
  type: FETCH_STATIONS_TO_SUCCESS,
  payload,
  id: fromStationId,
});

export const getStationTo = fromStationId => {
  return dispatch => {
    dispatch(requestStationsTo());
    Api.getToStation(fromStationId)
      .then(res => {
        dispatch(requestStationsToSuccess(fromStationId, res));
      })
      .catch(error => {
        dispatch(requestStationsToFailure(error));
      });
  };
};



// WEBPACK FOOTER //
// ./src/containers/ConnectionForm/actions.js